import type {
  EventType,
  EventTypeLink,
  LinkItem,
  SearchEndpointResponse
} from '@ps/isp-web-services-types';
import produce from 'immer';

import type { PreviousSearchResults } from '../components/SportsGlobalSearch/components/PreviousSearchResults/utils/get-previous-results';

import { defaultLinks, defaultState } from './defaultState';
import type { SearchResults } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  dataAzLoadSuccess: (state: State, payload: EventTypeLink[]): State => ({
    ...state,
    az: payload,
    azErrorCode: undefined,
    preloaded: true
  }),
  dataAzLoadFailed: (state: State, payload: string): State => ({
    ...state,
    azErrorCode: payload,
    preloaded: true
  }),
  dataPopularSuccess: (state: State, payload: LinkItem[]): State => ({
    ...state,
    popular: payload,
    preloaded: true
  }),
  searchLoadedSuccessfully: (state: State, payload: SearchEndpointResponse): State => ({
    ...state,
    search: {
      ...state.search,
      links: { ...payload },
      isFetching: false
    }
  }),
  searchLoadedUnsuccessfully: (state: State): State => ({
    ...state,
    search: {
      ...state.search,
      links: defaultLinks,
      isFetching: false
    }
  }),
  setSelectedEventType: (state: State, selectedEventTypeId: EventType | undefined): State => ({
    ...state,
    search: {
      ...state.search,
      selectedEventTypeId
    }
  }),
  updateSearchQuery: (state: State, payload: string): State => ({
    ...state,
    search: {
      ...state.search,
      query: payload
    }
  }),
  setSearchResults: (
    state: State,
    payload: { results: SearchResults; isNewSearchQuery: boolean }
  ) => ({
    ...state,
    search: {
      ...state.search,
      results: payload.results,
      isNewSearchQuery: payload.isNewSearchQuery
    }
  }),
  searchLoadRequest: (state: State): State => ({
    ...state,
    search: {
      ...state.search,
      isFetching: true
    }
  }),
  updatePreviousSearchResults: (state: State, payload: PreviousSearchResults) => ({
    ...state,
    search: {
      ...state.search,
      previousSearchResults: payload
    }
  }),
  togglePreviousSearchResults: (state: State, payload: boolean) => ({
    ...state,
    search: {
      ...state.search,
      showPreviousSearchResults: payload
    }
  })
};
